<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5>Создать запрос на получение баланса на картах</h5>
        <div>
          <p>Доставочные карты</p>
          <CustomMultiSelect
            ref="selectedDeliveryCards"
            :records="getCardsByType('deliveryPrePaid')" :options="{placeholder: 'Выберите карты', useAllSelect:true}"
          />
        </div>
        <div>
          <p>Региональные карты</p>
          <CustomMultiSelect
            ref="selectedRegionCards"
            :records="getCardsByType('regionsPrePaid')" :options="{placeholder: 'Выберите карты', useAllSelect:true}"
          />
        </div>
        <div>
          <p>Почтовые карты</p>
          <CustomMultiSelect
            ref="selectedPostCards"
            :records="getCardsByType('postPrePaid')" :options="{placeholder: 'Выберите карты', useAllSelect:true}"
          />
        </div>
      </div>
      <div class="card-footer text-right">
        <LoadingButton
          title="Создать задачу"
          :loading="btnLoading"
          :color="$constants.PRIMARY_COLOR"
          :onClick="() => createTask()"
          className="btn btn-outline-info"
        />
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <BalanceHistoryTasks ref="balanceHistory"/>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import CustomMultiSelect from "@/components/selects/CustomMultiSelect.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import BalanceHistoryTasks from "@/views/admin/settings/cards/components/BalanceHistoryTasks.vue";

export default {
  props: ['cards'],
  components: {
    LoadingButton,
    CustomMultiSelect,
    BalanceHistoryTasks,
  },
  data() {
    return {
      btnLoading: false,
    }
  },
  methods: {
    getCardsByType(type) {
      if (!this.cards) return [];
      return this.cards.reduce((acc, c) => {
        switch (type) {
          case 'deliveryPrePaid':
            if (c.use_type_id === 2) {
              acc.push({...c, selectTitle: c.number + ' (' + c.owner?.short_name + ')'});
            }
            break;
          case 'regionsPrePaid':
            if (c.use_type_id === 3) {
              acc.push({...c, selectTitle: c.number + ' (' + c.owner?.short_name + ')'});
            }
            break;
          case 'postPrePaid':
            if (c.use_type_id === 1) {
              acc.push({...c, selectTitle: c.number + ' (' + c.owner?.short_name + ')'});
            }
            break;
        }
        return acc;
      }, [{id: -1, selectTitle: 'Все карты'}])
    },
    async createTask() {
      this.btnLoading = true;
      const {data} = await api.post('/tasks/new', {
        type: 'balanceCollectBySms',
        cards: {
          2: this.$refs.selectedDeliveryCards.selectedRecords,
          3: this.$refs.selectedRegionCards.selectedRecords,
          1: this.$refs.selectedPostCards.selectedRecords,
        }
      })
      if (data.success) {
        toastr['success']('Задача создана');
        this.$refs.balanceHistory?.getRecords();
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading = false;
    }
  }
}

</script>
